/**
 * When there a re multiple tabs on a page we need a means to control which ones are active
 * - this includes having a control for what nested tabs are active
 * - to do that we use a dot path param method where each dot path segment represents an option within a Tab set e.g.
 * - A.D.J
 * -- A is an option within Tab 1
 * -- D is an option within Tab 2 which is a descendent of Tab 1
 * -- J is an option within Tab 3 which is a descendent of Tab 2
 * - We reference a path prefix to determine whether the Tab in context is a descendent of the active Tab
 * - if not we return the first available tab as a fallback
 * */
export const getActiveTabID = (tabs, pathPrefix, routerTab) => {
  const defaultActiveTab = tabs[0].id;
  if (routerTab) {
    const allowedTabs = tabs.map((tab) => tab.id);
    const re = new RegExp(`^${pathPrefix}.`);
    const isDescendent = re.test(routerTab);

    if (!pathPrefix || isDescendent) {
      /**
       * Find the active path by bisecting the router tab
       * e.g.
       * - active tab --> C
       * - routerTab --> A.B.C.D
       * - pathPrefix --> A.B
       * -- replace the front pathPrefix --> C.D
       * -- split but dot path and pick the first --> [C, D][0]
       * -- result is C
       */
      const bisectTop = pathPrefix ? routerTab.replace(re, "") : routerTab;
      const targetTabName = bisectTop.split(".")[0];
      const foundTabIndex = allowedTabs.indexOf(targetTabName);
      const foundTab =
        foundTabIndex > -1 ? allowedTabs[foundTabIndex] : defaultActiveTab;
      return foundTab;
    } else {
      return defaultActiveTab;
    }
  } else {
    return defaultActiveTab;
  }
};

/**
 * Ensure pathPrefix does not have a tab id as its last path fragment
 * - If it did then there would be a concatenation of tab paths
 * - And tab toggle active states would no longer work
 * @param {string} pathPrefix - tab realted dot path
 * @param {array} tabs - tabs wiithin context
 */
export const pathPrefixWithoutTabID = (pathPrefix, tabs) => {
  const pathParts = pathPrefix.split(".");
  const tabIds = tabs.map((tab) => tab.id);

  const lastPart = pathParts.slice(-1)[0];
  const lastPartMatchesAnId = tabIds.indexOf(lastPart) > -1;

  if (lastPartMatchesAnId) {
    return pathParts.slice(0, -1).join(".");
  }

  return pathPrefix;
};
